export default __webpack_public_path__ + "static/media/Gabby_BIO_Image.06d3d089.jpg";